import React from "react";
import { cn } from "../../../helpers/utils/css-utils";

const SectionHeading = ({ title = "", subtitle, className, children }) => {
  return (
    <div
      className={cn(
        "flex flex-none items-center justify-between gap-4 border-b border-gray-100 px-5 py-3.5",
        className
      )}
    >
      <div className="min-w-0">
        <h4 className="truncate text-base font-semibold tracking-tight text-gray-900 xl:text-lg">
          {title}
        </h4>
        {subtitle && (
          <p className="mt-0.5 truncate text-xs text-gray-500">
            {subtitle}
          </p>
        )}
      </div>
      {children && <div className="flex shrink-0 items-center gap-2">{children}</div>}
    </div>
  );
};

export default SectionHeading;
